import { NgTemplateOutlet } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { CANT_LOAD_TOO_FAST } from '../global';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  selector: 'app-stat-box',
  templateUrl: './stat-box.component.html',
  styleUrls: ['./stat-box.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, RouterModule, LoaderComponent, TranslatePipe, NgTemplateOutlet],
})
export class StatBoxComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private _stat: string | number;

  @Input()
  hasStat = true;

  @Input()
  name: string;

  @Input()
  icon: string;

  @Input()
  color: string;

  @Input()
  text: string;

  @Input()
  route: string;

  @Input()
  href: string;

  @Input()
  disabled = false;

  loading = false;
  loadingTimeout: any;

  ngOnInit(): void {
    this.loadingTimeout = setTimeout(() => {
      if (!this._stat && this._stat !== 0) {
        this.loading = true;
      }
    }, CANT_LOAD_TOO_FAST);
    this.destroyRef.onDestroy(() => clearTimeout(this.loadingTimeout));
  }

  @Input()
  set stat(value: string | number) {
    this._stat = value;

    clearTimeout(this.loadingTimeout);
    this.loading = false;
  }

  get stat(): string | number {
    return this._stat;
  }
}
